var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    [
      _c("v-card-title", { domProps: { innerHTML: _vm._s(_vm.title) } }),
      _c("v-card-text", { domProps: { innerHTML: _vm._s(_vm.text) } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }